var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.625,
    height: 31.625,
    x: 0.688,
    y: 0.688,
    fill: "#fff",
    stroke: "#D6DCE9",
    strokeWidth: 1.375,
    rx: 4.813
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M14.572 22.355h-2.908l-2.18-8.34c-.104-.384-.324-.724-.647-.883a9.445 9.445 0 0 0-2.666-.883v-.321h4.685c.646 0 1.131.482 1.212 1.042l1.131 6.017 2.907-7.06h2.827l-4.361 10.428Zm5.977 0h-2.746l2.261-10.427h2.746l-2.26 10.427Zm5.814-7.538c.081-.562.566-.883 1.132-.883.889-.08 1.857.08 2.665.48l.485-2.244a6.937 6.937 0 0 0-2.504-.482c-2.665 0-4.605 1.444-4.605 3.448 0 1.525 1.374 2.326 2.344 2.808 1.05.481 1.453.802 1.372 1.283 0 .722-.808 1.043-1.614 1.043-.97 0-1.94-.24-2.828-.642l-.484 2.246c.97.4 2.018.562 2.988.562 2.989.079 4.846-1.364 4.846-3.53 0-2.727-3.797-2.887-3.797-4.09Zm13.408 7.538-2.18-10.427h-2.342c-.485 0-.97.321-1.132.802l-4.037 9.625h2.827l.564-1.524h3.473l.324 1.524h2.503Zm-4.118-7.62.806 3.93H34.2l1.454-3.93Z",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;